import request from '@/util/request';

export const getFeeReturnList = (current, size, params) => {
  return request({
    url: '/api/feeBack/feereturn/page',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    },
  });
};

export const getFeeReturnDetail = (id) => {
  return request({
    url: '/api/feeBack/feereturn/detail',
    method: 'get',
    params: {
      id,
    },
  });
};

export const removeFeeReturn = (ids) => {
  return request({
    url: '/api/feeBack/feereturn/remove',
    method: 'post',
    params: {
      ids,
    },
  });
};

export const addFeeReturn = (row) => {
  return request({
    url: '/api/feeBack/feereturn/submit',
    method: 'post',
    data: row,
  });
};

export const updateFeeReturn = (row) => {
  return request({
    url: '/api/feeBack/feereturn/submit',
    method: 'post',
    data: row,
  });
};
